export const PEOPLE_SEARCH_ANALYTICS_EVENTS = {
  clickPeopleSearchResult: "click_people_search_result",
  hoverPeopleSuspendedStatusTooltip: "hover_people_suspended_status_tooltip"
} as const;
